<script>
//Importing Bar class from the vue-chartjs wrapper
import { Bar } from "vue-chartjs";
import { createNamespacedHelpers } from "vuex";
import dashboardService from "@/api/dashboardService";
const { mapState, mapActions } = createNamespacedHelpers("dashboard");
//Exporting this so it can be used in other components
export default {
  props: {
    dataItem: Object,
    dashboardData: Array
  },
  name: "Barchart",
  extends: Bar,
  data() {
    return {
      datacollection: {
        //Data to be represented on x-axis
        labels: [
          "Jan",
          "Feb",
          "March",
          "April",
          "May",
          "June",
          "July",
          "Aug",
          "Sept",
          "Oct",
          "Nov",
          "Dec"
        ],
        datasets: [
          {
            label: "Active Tenants",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "#0456d0",
            // borderColor: ["#111", "#111", "#111", "#111", "#111"],
            //Data to be represented on y-axis
            data: this.activatedTenants
          },
          {
            label: "Inactive Tenants",
            pointBackgroundColor: "white",
            borderWidth: 0,
            pointBorderColor: "#249EBF",
            backgroundColor: "grey",
            // borderColor: ["#111", "#111", "#111", "#111", "#111"],
            //Data to be represented on y-axis
            data: this.deActivatedTenants
          }
        ],
      },
      //Chart.js options that controls the appearance of the chart
      options: {
        scales: {
          yAxes: [
            {
              // ticks: {
              //   min: 0,
              //   max: 1000,
              //   stepSize: 250,
              //   reverse: false,
              //   beginAtZero: true
              // },
              ticks: {
                min: 0,
                max: 10,
                stepSize: 2,
                reverse: false,
                beginAtZero: true
              },
              gridLines: {
                display: false
              }
            }
          ],
          xAxes: [
            {
              gridLines: {
                display: false
              }
            }
          ]
        },
        legend: {
          display: true,
          position: 'bottom',
        },
        responsive: true,
        maintainAspectRatio: false
      },
      dataInfoVal: [],
      activatedTenants: [],
      deActivatedTenants: []
    };
  },
  //  watch: {
  //   dashboardData: function(newVal) {
  //    // console.log("data val", newVal);
  //     this.dataInfoVal = newVal;
  //   },
  // },
  methods: {
    ...mapActions(["getTenantDetailsOnYear"]),
    async getDataOnload() {
      this.dataInfoVal = this.dashboardData
      let data= {
        year: parseInt(this.dataInfoVal[1]?this.dataInfoVal[1]: this.currentYear),
        productID: this.dataInfoVal[0]?this.dataInfoVal[0]: 0
      }
      const response = await dashboardService.getTenantDetailsOnYear(data);
      this.activatedTenants = []
      response.data.forEach(session => {
        this.activatedTenants.push(session.activatedTenants)
      });
      this.deActivatedTenants = []
      response.data.forEach(session => {
        this.deActivatedTenants.push(session.deactivatedTenants)
      });
    }
  },
  computed:{
    ...mapState([ "prods", "years","currentYear"]),
    // ...mapMutations([ "getActivatedTenants", "getDeactivatedTenants"])
  },
  beforeMount() {
    //  this.dashboard = this.$store.getters["getTenantDetailsOnYear"]
  },
  async mounted() {
    
    this.dataInfoVal = this.dashboardData
      let data= {
        year: parseInt(this.dataInfoVal[1]?this.dataInfoVal[1]: this.currentYear),
        productID: this.dataInfoVal[0]?this.dataInfoVal[0]: 2
      }
      const response = await dashboardService.getTenantDetailsOnYear(data);
      this.activatedTenants = []
      response.data.forEach(session => {
        this.activatedTenants.push(session.activatedTenants)
      });
      this.deActivatedTenants = []
      response.data.forEach(session => {
        this.deActivatedTenants.push(session.deactivatedTenants)
      });
    try {
      this.datacollection.datasets[0].data = this.activatedTenants
      this.datacollection.datasets[1].data = this.deActivatedTenants
      this.renderChart(this.datacollection, this.options);
    } catch (e) {
      console.log(e);
    }
  },
  
  // created(){
  //   this.getDataOnload();
  // }
};
</script>